import {useMemo} from 'react';
import {useAllowSoftTickerEvents} from 'app/hooks/useAllowSoftTicker';

export default function useShowAddScorerButton(match: any, tickerEvents: any[]): boolean {
  const goalEventNeeded = useMemo(() => {
    if (!match.homeGoal && !match.awayGoal) {
      return false;
    }
    const numberOfGoals = Number(match.homeGoal) + Number(match.awayGoal);
    const goalEvents = tickerEvents.filter(event => event.type === 'matchevent' && event.entity?.type === 'goal');
    return goalEvents.length < numberOfGoals;
  }, [match, tickerEvents]);

  const allowLiveResult = useAllowSoftTickerEvents(match);

  return goalEventNeeded && allowLiveResult;
}
